import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { addToCarts } from "../../../../../../api"
import { IMAGE_GEEKO_LTD } from "../../../../../../constants"
import { action_fetch_cart, action_fetch_cart_count, setCartTrigger } from "../../../../../../store/actions/global"
import { action_fetch_often_with_products, action_fetch_product_coupon_message } from "../../../../../../store/actions/pages/product"
import { getLowerPrice } from "../../../../../../utils/product"
import GeekoEvents from '../../../../../ads/events'


export const useShopTheLook = () => {
    const pageGlobal = useSelector(state => state.global)
    const dispatch = useDispatch()
    const [cartImage, setCartImage] = useState(null)
    const [selectedName, setSelectedName] = useState("youlikes")
    const [loading, setLoading] = useState(false)

    const productsAddToCart = async (list, selectedProduct, shopTheLookProductId) => {
        setLoading(true)
        
        const addedVariants = list?.filter(sv => sv.quantity > 0)?.map?.(sv => ({
            quantity: sv?.quantity,
            variantId: sv?.variant?.id,
            unifiedId: sv?.variant?.domesticDelivery?.enabled ? sv?.variant.unifiedId : undefined,
            warehouseId: sv?.variant?.domesticDelivery?.enabled ? sv?.variant.domesticDelivery?.warehouseId : undefined,
            shippedCountryCode: sv?.variant?.domesticDelivery?.enabled ? sv?.variant.domesticDelivery?.countryCode : undefined,
            shopTheLookProductId: shopTheLookProductId
        }))
    
        const response = await addToCarts(addedVariants)
       
        try {
            // const lower = getLowerPrice(selectedProduct)
            // addedVariants?.forEach(sv => {
            //     GeekoEvents.addToCart({
            //         productId: selectedProduct?.id,
            //         sku: selectedProduct.parentSku,
            //         variantId: sv?.variant?.id,
            //         variantSku: sv?.variant?.sku,
            //         quantity: sv?.quantity,
            //         amount: lower?.amount,
            //         currency: lower?.currency,
            //         variantSize: sv?.size,
            //         usdPrice: sv?.salesPriceWithUSD?.amount,
            //         name: selectedProduct.name,
            //         is_success: response?.code === 200,
            //     })
            // })
            let is_success = response?.code === 200
            list.forEach(l => {
                const lower1 = getLowerPrice(l?.product)
                
                GeekoEvents.addToCart({
                    page_title: '商详页',
                    
                    productId: l?.product?.id,
                    quantity: l?.quantity,
                    usdPrice: l?.variant?.salesPriceWithUSD?.amount,
                    variantSize: l?.variant?.size,
                    is_success,
                    sku: l?.product?.parentSku,
                    variantSku: l?.variant?.sku,
                    amount: lower1?.amount,
                    currency: lower1?.currency,
                    name: l?.product?.name,
                    sensors: {
                        product_position: l?.product_position,
                        resourcepage_title: 'product',
                        resource_position: '2',
                        resource_type: '20',
                        resource_content: 'shop the look',
                    }
                })
            })
            
        } catch (e) {
            console.error(e)
        }

        setLoading(false)
    
        if (response?.code === 200) {
            // pc处理购物车方式
            if(pageGlobal?.isDesktop){
                await dispatch(action_fetch_cart());
                dispatch(setCartTrigger());
            }else{
                if(document.getElementById("youLikesNav")){
                    let domCurrent = document.getElementById("youLikesNav");
                    let currentOffsetTop = domCurrent.offsetTop + domCurrent.offsetParent.offsetTop;
                    // console.log('currentOffsetTop', currentOffsetTop)
        
                    window.scrollTo({
                        top: currentOffsetTop - 98,
                        behavior: 'smooth'
                    })
                }
                setCartImage(`${IMAGE_GEEKO_LTD}/small/${list?.[0]?.image}`)
    
                setTimeout(() => {
                    setCartImage(null)
                }, 400)
    
                dispatch(action_fetch_product_coupon_message())
    
                setSelectedName('oftenwith');
                 
                // dispatch(action_fetch_often_with_products(selectedProduct?.id));
            }
    
            dispatch(action_fetch_cart_count())
        }
    
        return response
    }

    const findSameVariant = (product, color, size) => {
        const isShoe = product?.isShoe
        let variant = ''
        const sameColorAndSizeVariant = product?.variants.find(v => v.color == color && v.size == size)
        if(sameColorAndSizeVariant){
            // console.log('有颜色尺码一样的')
            return sameColorAndSizeVariant
        } else {
            const sameColorVariant = product?.variants.find(v => v.color == color)
            if(sameColorVariant){
                // console.log('有颜色一样的')
                return sameColorVariant
            } else {
                const sameSizeVariant = product?.variants.find(v => v.size == size)
                if(sameSizeVariant){
                    // console.log('有尺码一样的')
                    return sameSizeVariant
                } else {
                    // console.log('没有颜色尺码一样的')
                    return product?.variants?.[0]
                }
            }
        }
    }

    return {
        selectedName,
        loading,
        cartImage,
        productsAddToCart,
        findSameVariant
    }
}






